/**
 * `/:world/books`: every published work in publication order, with its year. One
 * language only, the interface's: both titles belong on the book's own page,
 * where somebody looking for the original title will find it.
 */

import { Link } from 'react-router'
import { worldPath } from '../../shared/routes.ts'
import { CataloguePage, usePageTitle } from '../components/Catalogue.tsx'
import { useI18n } from '../i18n/index.tsx'
import { mainTitle } from '../lib/catalogue.ts'

export function Books() {
  const { t, locale } = useI18n()
  usePageTitle(t('books.title'))

  return (
    <CataloguePage>
      {(catalogue, world) => (
        <section className="panel">
          <h1>{t('books.title')}</h1>
          <ol className="list-plain" aria-label={t('books.title')}>
            {catalogue.works.map((work) => (
              <li key={work.slug}>
                {work.year_first_published === null ? null : (
                  <span className="year">{`${String(work.year_first_published)} — `}</span>
                )}
                <Link to={worldPath(world, 'books', work.slug)}>{mainTitle(work, locale)}</Link>
              </li>
            ))}
          </ol>
        </section>
      )}
    </CataloguePage>
  )
}
